import React, { useCallback, useEffect, useState } from "react";
import { columnsEnquiry } from "../../Global Functions/columnsAntd";
import { useDispatch, useSelector } from "react-redux";
import { getEnquiriesList } from "../../Redux/Actions/enquiriesAction";
import { useParams } from "react-router-dom";
import DateRangePopup from "../../Utils/dateFilterPopup";
import toast from "react-hot-toast";
import TableComponentsCp from "../../Global Functions/tableComponentsCp";

const ListEnquiries = () => {
  const dispatch = useDispatch();
  const { id } = useParams();

  const [searchQuery, setSearchQuery] = useState("");
  const [isDatePopupVisible, setIsDatePopupVisible] = useState(false);
  const [dateRange, setDateRange] = useState({ start: null, end: null });
  const [debouncedSearch, setDebouncedSearch] = useState(searchQuery);

  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
    showSizeChanger: true,
    pageSizeOptions: ["5", "10", "20", "50", "100"],
  });

  const { enquiries, loading } = useSelector((state) => state.enquiries || {});
  const enquireyList = enquiries?.data;

  console.log("Datatat=====>", enquireyList)

  // Debounce searchQuery → debouncedSearch (500ms)
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearch(searchQuery);
    }, 500);
    return () => clearTimeout(handler);
  }, [searchQuery]);

  // Reset to page 1 when search changes
  useEffect(() => {
    setPagination((prev) => ({ ...prev, current: 1 }));
  }, [debouncedSearch]);

  // fetchDetails with useCallback (depends on debouncedSearch, dateRange, id)
  const fetchDetails = useCallback(async (page, limit, showLoader = true) => {
    const enquiryData = {
      page,
      limit,
      is_deleted: false,
      search: debouncedSearch,
      ...(id && { project_id: id }),
      ...(dateRange.start && { start_date: dateRange.start.format("YYYY-MM-DD") }),
      ...(dateRange.end && { end_date: dateRange.end.format("YYYY-MM-DD") }),
    };

    try {
      await dispatch(getEnquiriesList(enquiryData, showLoader));
      if (!showLoader) {
        toast.success("Enquiries list refreshed");
      }
    } catch {
      if (!showLoader) {
        toast.error("Failed to refresh enquiries list");
      }
    }
  }, [dispatch, debouncedSearch, dateRange, id]);

  // Fetch on pagination or filter change
  useEffect(() => {
    fetchDetails(pagination.current, pagination.pageSize);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination.current, pagination.pageSize, fetchDetails]);

  // Sync total count
  useEffect(() => {
    if (enquiries?.total) {
      setPagination((prev) => ({ ...prev, total: enquiries.total }));
    }
  }, [enquiries]);

  const handleTableChange = (pagination) => {
    setPagination(pagination);
  };

  // Date range apply handler
  const handleDateRangeApply = (start, end) => {
    if (start === null && end === null) {
      setDateRange({ start: null, end: null });
    } else {
      setDateRange({ start, end });
    }
    setIsDatePopupVisible(false);
    setPagination((prev) => ({ ...prev, current: 1 }));
  };

  return (
    <>
      <TableComponentsCp
        columns={columnsEnquiry}
        h3heading="Enquiries List"
        navigateTo2="/enquiry"
        pagination={pagination}
        dataSource={Array.isArray(enquiries?.data) ? enquiries.data : []}
        onChange={handleTableChange}
        setState={setSearchQuery}                             
        onCalendarClick={() => setIsDatePopupVisible(true)}   
        loading={loading}                                       
      />

      <DateRangePopup
        visible={isDatePopupVisible}
        initialStart={dateRange.start}
        initialEnd={dateRange.end}
        onCancel={() => setIsDatePopupVisible(false)}
        onOk={handleDateRangeApply}
      />
    </>
  );
};

export default ListEnquiries;